/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const ErrorMessage = Object.freeze({
    nonDeliverable: 'Sorry we don’t ship to Hawaii or Alaska',
    stateValidtion: 'Please select delivery state.',
    selectStateError: 'Please select delivery state first',
    nonDeliverableOther: 'Please shop our collection of plants that are available in your delivery location.',
    outOfStockCheckout: 'Sorry we can not deliver this product to your intended destination. Please try another.',
});

export default ErrorMessage;
